import { jsPDF } from 'jspdf';

/**
 * A one-page PDF holding a chart screenshot at its own pixel size: the PDF export in ChartExport.
 */
const chartImageToPdf = (pngDataUrl: string, width: number, height: number): jsPDF => {
    // eslint-disable-next-line new-cap
    const pdf = new jsPDF({
        orientation: 'landscape',
        unit: 'px',
        format: [width, height],
    });

    pdf.addImage(pngDataUrl, 'PNG', 0, 0, width, height);

    return pdf;
};

export default chartImageToPdf;
